<template>
  <div class="wrapper plan-edit-bar">
    <div class="columns top-header w-row">
      <div class="pricing-v3-cell-mobile w-clearfix w-col w-col-4 w-col-small-4 w-col-tiny-4">
        <img
          v-if="currentStep === 1"
          src="signUp/images/pen-white.svg"
          alt=""
          class="button-icon bigger"
        >
        <div
          v-if="currentStep === 1"
          class="mobile-text-block"
        >
          Editing Personal Info
        </div>
        <div
          v-else
          class="mobile-text-block"
        >
          Current Personal Info
        </div>
      </div>
      <div class="pricing-v3-cell-mobile w-col w-col-4 w-col-small-4 w-col-tiny-4">
        <img
          v-if="currentStep === 2"
          src="signUp/images/pen-white.svg"
          alt=""
          class="button-icon bigger"
        >
        <div
          v-if="currentStep === 2"
          class="mobile-text-block not-editing"
        >
          Currently Editing Plan<br>
        </div>
        <div
          v-else
          class="mobile-text-block not-editing"
        >
          Current Plan<br>
        </div>
      </div>
      <div class="pricing-v3-cell-mobile w-col w-col-4 w-col-small-4 w-col-tiny-4">
        <img
          v-if="currentStep === 3"
          src="signUp/images/pen-white.svg"
          alt=""
          class="button-icon bigger"
        >
        <div
          v-if="currentStep === 3"
          class="mobile-text-block not-editing"
        >
          Editing Add Ons<br>
        </div>
        <div
          v-else
          class="mobile-text-block not-editing"
        >
          Current Add Ons<br>
        </div>
      </div>
    </div>
    <div class="columns w-row">
      <div class="pricing-v3-cell-mobile w-col w-col-4 w-col-small-4 w-col-tiny-4">
        <div class="text-block-5">
          {{ currentPatient.first_name }}<br><span class="text-span-3">{{ currentPatient.birth_date }}</span><br>
        </div>
      </div>
      <div class="pricing-v3-cell-mobile w-col w-col-4 w-col-small-4 w-col-tiny-4">
        <div class="mobile-text-block">
          {{ currentPatient.plan.display_name }}<br>
        </div>
      </div>
      <div class="pricing-v3-cell-mobile w-col w-col-4 w-col-small-4 w-col-tiny-4">
        <div class="mobile-text-block">
          <span
            v-for="(addon, index) in currentPatient.addons"
            :key="addon.id"
          >
            <span>{{ addon.display_name }}</span><span v-if="index+1 < currentPatient.addons.length"> | </span>
          </span><br>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Signup4Component',
  props: {
    currentStep: {
      type: Number,
      default: 1
    },
    currentPatient: {
      type: Object,
      default: null
    }
  },
  data () {
    return {

    }
  }
}
</script>
